import React, { useState } from 'react';

function OrderFlowPriceCalculator() {
  const [salesPrice, setSalesPrice] = useState('');
  const [inputTaxCredit, setInputTaxCredit] = useState('');
  const [gstRate, setGstRate] = useState('');
  const [result, setResult] = useState(null);

  const handleCalculate = () => {
    const salesPriceNum = parseFloat(salesPrice);
    const inputTaxCreditNum = parseFloat(inputTaxCredit);
    const gstRateNum = parseFloat(gstRate);

    // Validate inputs
    if (isNaN(salesPriceNum) || isNaN(inputTaxCreditNum) || isNaN(gstRateNum) || salesPriceNum <= 0 || gstRateNum <= 0) {
      alert('Please enter valid numbers for all fields.');
      return;
    }

    

    // Calculate GST and amounts
    const gstAmount = (salesPriceNum * gstRateNum) / (100 + gstRateNum);

    const bankchargesAmount = salesPriceNum * 0.03;
    const cashbackAmount = salesPriceNum * 0.05;
    const mlmAmount = salesPriceNum * 0.35;
    const markupRate = 0.24; // 70% markup
    const platformAmount = salesPriceNum * markupRate;

    // const platformAmount = (salesPriceNum * markupRate) + (1.7 * gstAmount);
    const transferPrice = salesPriceNum - bankchargesAmount - cashbackAmount - mlmAmount - platformAmount + inputTaxCreditNum;

    // // Calculate transfer price
    // const transferPrice = sellerAmount + inputTaxCreditNum;

    setResult({
      gstAmount,
      bankchargesAmount,
      cashbackAmount,
      mlmAmount,
      platformAmount,
      transferPrice
    });
  };

  const formattedSalesPrice = parseFloat(salesPrice).toFixed(2);


  return (
    <div className="border border-spacing-1 border-yellow-200 py-2 px-2 text-white">
      <h1 className='text-2xl text-orange-300'>Calculate Transfer Price</h1>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleCalculate();
        }}
      >
        <div className='mt-2 flex flex-col'>
          <label>Sales Price (Including GST):</label>
            <input
                type="number"
                value={salesPrice}
                onChange={(e) => setSalesPrice(e.target.value)}
                required
                className='text-black bg-white'
                style={{
                    border: '1px solid #ccc',
                    padding: '8px',
                    width: '200px',
                    boxSizing: 'border-box',
                  }}
            />
        </div>
        <div className='mt-4 flex flex-col'>
          <label>GST Rate (%):</label>
          <input
            type="number"
            value={gstRate}
            onChange={(e) => setGstRate(e.target.value)}
            required
            className='text-black bg-white'
            style={{
                border: '1px solid #ccc',
                padding: '8px',
                width: '100px',
                boxSizing: 'border-box',
              }}
          />
        </div>
        <div className='mt-4 flex flex-col'>
          <label>Input Tax Credit Amount:</label>
          <input
            type="number"
            value={inputTaxCredit}
            onChange={(e) => setInputTaxCredit(e.target.value)}
            required
            className='text-black bg-white'
            style={{
                border: '1px solid #ccc',
                padding: '8px',
                width: '200px',
                boxSizing: 'border-box',
              }} 
          />
        </div>
        
        <button className="mt-4" type="submit">Calculate</button>
      </form>

      {result && (
        <div className='mt-4'>
        <h2 className='text-xl text-yellow-300'>Calculation Results:</h2>
        <p>
          <strong>Sales / Offer Price:</strong> ₹
          {formattedSalesPrice ? parseFloat(formattedSalesPrice).toFixed(2) : '0.00'}
        </p>
        <p>
          <strong>Will go to Government Kitty - GST Amount:</strong> ₹
          {result && result.gstAmount !== undefined && !isNaN(result.gstAmount) 
            ? result.gstAmount.toFixed(2) 
            : '0.00'}
        </p>
        <p>
          <strong>Bank Charges & Processing Fee inclusive of GST:</strong> ₹
          {result && result.bankchargesAmount !== undefined && !isNaN(result.bankchargesAmount) 
            ? result.bankchargesAmount.toFixed(2) 
            : '0.00'}
        </p>
        <p>
          <strong>Cashback - will go to Customer Think5Whys Wallet:</strong> ₹
          {result && result.cashbackAmount !== undefined && !isNaN(result.cashbackAmount) 
            ? result.cashbackAmount.toFixed(2) 
            : '0.00'}
        </p>
        <p>
          <strong>Will be distributed as MLM Fee:</strong> ₹
          {result && result.mlmAmount !== undefined && !isNaN(result.mlmAmount) 
            ? result.mlmAmount.toFixed(2) 
            : '0.00'}
        </p>
        <p>
          <strong>Will go as Platform Fee:</strong> ₹
          {result && result.platformAmount !== undefined && !isNaN(result.platformAmount) 
            ? result.platformAmount.toFixed(2) 
            : '0.00'}
        </p>
        <p>
          <strong>Your Transfer Price:</strong> ₹
          {result && result.transferPrice !== undefined && !isNaN(result.transferPrice) 
            ? result.transferPrice.toFixed(2) 
            : '0.00'}
        </p>
        {/* <p>
          <strong>Seller Amount:</strong> ₹
          {result && result.sellerAmount !== undefined && !isNaN(result.sellerAmount) 
            ? result.sellerAmount.toFixed(2) 
            : '0.00'}
        </p> */}
      </div>
      )}
    </div>
  );
}

export default OrderFlowPriceCalculator;
